import React, {useEffect, useState} from 'react';
import {SafeAreaView, StyleSheet, View} from 'react-native';

import OnboardingActionPanel from '../../views/onboarding/OnboardingActionPanel';
import OnboardingSlideScreen1 from './OnboardingSlideScreen1';
import OnboardingSlideScreen2 from './OnboardingSlideScreen2';
import OnboardingSlideScreen3 from './OnboardingSlideScreen3';

const slides = [
  OnboardingSlideScreen1,
  OnboardingSlideScreen2,
  OnboardingSlideScreen3,
];

interface ComponentProps {
  hideActions?: boolean;
}

const OnboardingSliderScreen = ({hideActions}: ComponentProps) => {
  const [activeIndex, setActiveIndex] = useState(0);
  const ActiveSlide = slides[activeIndex];

  useEffect(() => {
    const timer = window.setInterval(() => {
      setActiveIndex(current => (current + 1) % slides.length);
    }, 5000);
    return () => window.clearInterval(timer);
  }, []);

  return (
    <SafeAreaView style={styles.root}>
      <View style={styles.slide}>
        <ActiveSlide />
      </View>
      <OnboardingActionPanel
        size={slides.length}
        activeIndex={activeIndex}
        hideActions={hideActions}
        goBack={() => setActiveIndex(current => Math.max(0, current - 1))}
        goNext={() =>
          setActiveIndex(current => Math.min(slides.length - 1, current + 1))
        }
        onComplete={() => undefined}
        onIndicatorPress={setActiveIndex}
      />
    </SafeAreaView>
  );
};

const styles = StyleSheet.create({
  root: {
    flex: 1,
    width: '100%',
    height: '100%',
    paddingVertical: 16,
    backgroundColor: '#2BA8E81A',
  },
  slide: {
    flex: 1,
    overflow: 'hidden',
  },
});

export default OnboardingSliderScreen;
